import React, { useEffect, useState } from 'react'
import { Desc } from '../../Components/Typography/Text.styles'
import { colors } from '../../Components/consts'
import { SelectTeamData } from '../../Api/Teams/team.types'
import { useParams } from 'react-router-dom'
import { logEvent, getCurrentUrl } from '../../Utils'
import { useAuthContext } from '../../Context'
import { DEFAULT_EXTRA_LOGIN_FIELDS, updateFavoriteTeam } from '../../Api'
import { useQuery } from '../../Routing'
import { selectTeamDataArr } from '../../Constant/team'
import { SelectBottom, SelectInner, SelectOuter } from './components/styles'
import { SignInMoreData } from '../../Components/Auth/SignInMoreData'
import { WelcomeToTeam } from './components/WelcomeToTeam'
import { Lk } from '../../Components/Links/Lk'

const TeamSelect: React.FC<React.PropsWithChildren<unknown>> = () => {
  let params = useParams()
  let query = useQuery()
  let authQuery = query.get('auth')
  const { isAnonymous, isLoggedIn, zip, firstName, lastName, login, favTeam } =
    useAuthContext()
  const [favoriteTeam, setFavoriteTeam] = useState<string>()
  const [selectTeamData, setSelectTeamData] = useState<SelectTeamData | null>(null)
  const [flowStep, setFlowStep] = useState<number>(1)

  useEffect(() => {
    const teamParam = params.teamSlug
    if (teamParam) {
      let lowerCased = teamParam.toLowerCase()
      const tmData = selectTeamDataArr.find((t) =>
        lowerCased?.includes(t.fullName.toLowerCase())
      )
      tmData && setSelectTeamData(tmData)
    }
  }, [])

  useEffect(() => {
    if (isAnonymous) return
    const pending = sessionStorage.getItem('pending_team_fav')
    if (pending) {
      sessionStorage.removeItem('pending_team_fav')
      pledgeTeam(pending)
    }
  }, [isLoggedIn])

  const pledgeTeam = async (teamName: string) => {
    if (!authQuery) {
      //Navigate to Email Form

      return
    }
    if (isAnonymous) {
      log('fav_team_click_no_auth')
      sessionStorage.setItem('pending_team_fav', teamName)
      sessionStorage.setItem('login_text', 'Login to pledge your team')
      return login(DEFAULT_EXTRA_LOGIN_FIELDS)
    }
    if (teamName === favTeam) {
      //Already favorited
      checkHasUserData()
      return
    }
    const { success, team } = await updateFavoriteTeam(teamName)
    if (!success || !team) return alert('Could not add team to favorites. Try again')

    setFavoriteTeam(team)
    log('fav_team_click')
    checkHasUserData()
  }

  const checkHasUserData = () => {
    if (zip && firstName && lastName) {
      setFlowStep(3) //Show Team success
    } else {
      setFlowStep(2) // Get missing info
    }
  }

  const log = (event: string) => {
    logEvent(event, {
      favorite_team: favoriteTeam,
      auth_status: isLoggedIn && !isAnonymous ? 'logged_in' : 'no_auth',
    })
  }

  return (
    <SelectBottom>
      <SelectOuter>
        {selectTeamData && flowStep === 1 && (
          <SelectInner>
            <Desc textColor={colors.white}>{selectTeamData.joinText}</Desc>
            {authQuery && (
              <button onClick={() => pledgeTeam(selectTeamData.fullName)}>
                {selectTeamData.buttonText}
              </button>
            )}
            {!authQuery && (
              <Lk link={selectTeamData.link} alt={selectTeamData.buttonText}>
                {selectTeamData.buttonText}
              </Lk>
            )}
          </SelectInner>
        )}
        {flowStep === 2 && (
          <SignInMoreData
            extraFields={['zip', 'name']}
            allowSkip={false}
            onFinishedSubmit={() => setFlowStep(3)}
            uiTheme="dark"
          />
        )}
        {flowStep === 3 && favoriteTeam && (
          <WelcomeToTeam
            team={selectTeamData}
            favoriteTeam={favoriteTeam}
            link={getCurrentUrl().split('?')[0]}
          />
        )}
      </SelectOuter>
    </SelectBottom>
  )
}

export default TeamSelect
